import React from 'react';
import { Link } from "react-router-dom";

class Home extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      bgLoaded: false,
      bgError: false // Track if image fails to load
    };

    this.imageUrl =
    'https://images.unsplash.com/photo-1589278466892-cf6bf811efef?q=80&w=1170&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D';
  };

  componentDidMount() {
  const img = new Image();
  img.crossOrigin = 'anonymous'; // CORS support
  img.src = this.imageUrl;

  img.onload = () => {
    this.setState({ bgLoaded: true });
  };

  img.onerror = () => {
    //fallback color if image fails
    this.setState({ bgError: true });
    console.warn('Background image failed to load');
  };
}

  render() {
    const { bgLoaded } = this.state; // ← Destructure state
    return (
      <div id="content">
        <header
        id="showcase"
                style={{ 
          backgroundImage: bgLoaded ? `url(${this.imageUrl})` : 'none',
          backgroundColor: bgLoaded ? 'transparent' : '#1a1a2e'
    }}
        >
          <div className="showcase-content">
            <div className="container">
              <img src={require('./img/home-img.jpg')} title="A headshot of me" alt='A headshot of me' />
              <h1>
                Gabe <span className='text-primary'>Sequeira</span>
                <br />
                Full-Stack <span className="text-primary"> Developer</span>
              </h1>
              <Link to="/about" className="btn">
                TELL ME MORE
              </Link>
            </div>
          </div>
        </header>
        {/* Section: contact */}
   {/*     <section id='contact' className='bg-light'>
  <div className='container' style={{ textAlign: 'center', padding: '4rem 0' }}>
    <h2>Get in <span className='text-primary'>Touch</span></h2>
    <p style={{ fontSize: '1.2rem', maxWidth: '500px', margin: '0 auto' }}>
      The best way to reach me is by email or GitHub.
    </p>
    <div style={{ marginTop: '2rem', display: 'flex', justifyContent: 'center', gap: '2rem' }}>
      <a href='https://github.com/gabesequeira' className='btn'>GitHub</a>
      <a href='mailto:gabesb@proton.me' className='btn-dark'>
        gabe [at] gabesequeira [dot] com
      </a>
    </div>
  </div>
</section>

<section id='contact' className='bg-light'>
  <div className='container'>
    <h2>Let's <span className='text-primary'>Connect</span></h2>
    <p style={{ textAlign: 'center', fontSize: '1.2rem', maxWidth: '600px', margin: '0 auto' }}>
      Find me on <a className='btn' href='https://github.com/gabesequeira'>GitHub</a> or reach out at <strong>gabe [at] gabesequeira [dot] com</strong>.
    </p>
  </div>
</section> */}



        {/*Old contact form code for posterity*/}
        {/*<section id='contact' className='bg-light'>
          <div className='container'>
            <h2>Contact <span className='text-primary'>Me</span></h2>
            <div className='form-container'>
              <div className='mail-icon'><i className='fas fa-envelope'></i></div>
              <div className='form-box'>
                <h3>Send me a <span className='text-primary'>Message</span></h3>
                <form>
                  <div className='form-group'>
                    <label htmlFor='first-name'>First Name</label>
                    <input type='text' placeholder='Enter Your First Name'></input>
                  </div>
                  <div className='form-group'>
                    <label htmlFor='last-name'>Last Name</label>
                    <input type='text' placeholder='Enter Your Last Name'></input>
                  </div>
                  <div className='form-group'>
                    <label htmlFor='email'>Email</label>
                    <input type='email' placeholder='Enter Your Email'></input>
                  </div>
                  <div className='form-group'>
                    <label for='message'>Message</label>
                    <textarea rows='7' placeholder='Enter your message here'></textarea>
                  </div>
                  <input type='submit' value='Send Message' className='contact-btn'></input>
                </form>
              </div>
            </div>
          </div>
        </section>*/}
      </div>
    );
  }
}

export default Home;
